import React from "react";
import {
  Attachment3dModel,
  AttachmentImage,
  GallerySlider as GallerySliderUI,
  GallerySliderProps,
} from "@msys/ui";
import { useTranslate } from "@tolgee/react";

export const GallerySlider = <I extends AttachmentImage | Attachment3dModel>(
  props: GallerySliderProps<I>
) => {
  const { t } = useTranslate("Global");
  return (
    <GallerySliderUI
      downloadTitle={t("Download")}
      addTitle={t("Add")}
      rotateTitle={t("Rotate")}
      deleteTitle={t("Delete")}
      arButtonTitle={t("View in your space")}
      {...props}
    />
  );
};
